import { render, staticRenderFns } from "./ButtonOpenHelp.vue?vue&type=template&id=370b4702"
import script from "./ButtonOpenHelp.vue?vue&type=script&lang=js"
export * from "./ButtonOpenHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports